import React from "react";
import { template, setLocalStorage, transformAssetsUrl } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto, HtmlContent } from "@reco-w/core-ui";
import { Namespaces } from "@reco-w/about-models";
import { BackTopBox } from "./backTopBox";
import SwiperCore, { Autoplay } from "swiper/core";
import { Col, Modal, Row } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { EnumGroupHomeTag, r2040ArticleService } from "@reco-w/common-common";

// install Swiper modules
SwiperCore.use([Autoplay]);
export namespace About {
    export interface IProps extends ViewComponent.IProps { }

    export interface IState extends ViewComponent.IState { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.about;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", "/about"); // 设置被选中的菜单
            r2040ArticleService.getPaged({
                pageSize: 9999, inTagIds: [
                    EnumGroupHomeTag.yuanghd,
                    EnumGroupHomeTag.zhaopgw,
                ], isValid: true, orderBy: 'isTop,sequence,id desc'
            }).then(d => {
                this.dispatch("input", { yuanghd: d.items.filter(x => `,${x.tagIds},`.indexOf(EnumGroupHomeTag.yuanghd) > -1) });
                this.dispatch("input", { zhaopgw: d.items.filter(x => `,${x.tagIds},`.indexOf(EnumGroupHomeTag.zhaopgw) > -1) });
            });
        }

        componentDidMount() {
            this.dispatch({ type: "input", data: { isModalVisible: false } });
        }

        renderBody(): React.ReactNode {
            const fwData = [
                {
                    title: "创新者",
                    kh: "出奇制胜",
                    img: "assets/images/guanw/jzg-img1.jpg",
                },
                {
                    title: "进取者",
                    kh: "开疆扩土",
                    img: "assets/images/guanw/jzg-img2.jpg",
                },
                {
                    title: "务实者",
                    kh: "攻艰克难",
                    img: "assets/images/guanw/jzg-img3.jpg",
                },
                {
                    title: "担当者",
                    kh: "力挽狂澜",
                    img: "assets/images/guanw/jzg-img4.jpg",
                },
            ];
            const { yuanghd = [], zhaopgw = [] } = this.props.state!;

            return (
                <div className="content about-wid">
                    <Banner.Component
                        extraClass="large"
                        bimg="assets/images/guanw/jrwm-banner.jpg"
                        cimg=""
                        text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">加入我们</div>
                                <div className="banner-text-name2 mt25">一群人、一件事、一起拼、一定赢</div>
                            </div>
                        }
                    />
                    <div className="container">
                        <div className="block-content company-content">
                            <div className="container padding-h-xs">
                                <div className="second-title">
                                    <span>招聘岗位</span>
                                </div>
                                <Row gutter={[20, 20]} className="gw-row">
                                    {zhaopgw.map((item, i) => {
                                        return (
                                            <Col xs={12} sm={12} md={8} lg={8} key={i}>
                                                <div
                                                    className="job-item"
                                                    onClick={() => {
                                                        this.dispatch({ type: "input", data: { modal: true, text: item.content, title: item.title } });
                                                    }}
                                                >
                                                    <div className="job-item-content">
                                                        {/*<div className={this.classnames("recogroup size-66", item.icon)}></div>*/}
                                                        <div className="job-icon">
                                                            <img src={transformAssetsUrl(item.logo)} />
                                                        </div>
                                                        <div className="title">{item.title}</div>
                                                        <div className="desc">{item.summary}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                                <a className="base-btn" target='_blank' href="https://www.zhipin.com/gongsi/job/07a6fc53a766321b1HZ73d21GFs~.html?ka=company-jobs">加入我们</a>
                            </div>
                        </div>
                    </div>
                    <Modal
                        title={<div className="size-18 primary-color font-weight-normal">{this.props?.state!.title}</div>}
                        centered
                        open={this.props?.state!.modal}
                        footer={null}
                        width={1200}
                        onCancel={() => {
                            this.dispatch({ type: "input", data: { modal: false } });
                        }}
                    >
                        <div className="size-16" style={{ lineHeight: 2 }}>
                            <HtmlContent.Component html={this.props?.state!.text}></HtmlContent.Component>
                        </div>
                    </Modal>
                    <div className="culture-content">
                        <div className="container">
                            <div className="second-title">
                                <span>文化价值观</span>
                            </div>
                            <Row gutter={[18, 18]} className="jzg-row">
                                {fwData.map((item, i) => {
                                    return (
                                        <Col xs={24} sm={24} md={12} xl={12} key={i}>
                                            <div className="jzg-item">
                                                <ImageAuto.Component src={item.img} width="100%" height="330px" radius={0} />
                                                <div className="kc-item-write">
                                                    <div className="kc-item-title"><span>{item.title}</span>{item.kh}</div>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </div>
                    <div className="container">
                        <div className="yg-margin">
                            <div className="second-title">
                                <span>员工活动</span>
                            </div>
                            <Row gutter={[20, 20]}  className="hd-row">
                                {yuanghd.map((item, i) => {
                                    return (
                                        <Col xs={24} sm={24} md={12} xl={8} key={i}>
                                            <div
                                                className="photo-item"
                                                onMouseEnter={() => {
                                                    this.dispatch({ type: "input", data: { [`activityItem${i}`]: true } });
                                                }}
                                                onMouseLeave={() => {
                                                    this.dispatch({ type: "input", data: { [`activityItem${i}`]: false } });
                                                }}
                                            >
                                                <ImageAuto.Component className="photo-image" width="100%" height="100%" src={item.logo}></ImageAuto.Component>
                                                <div className="photo-text">{item.title}</div>
                                                {this.props!.state![`activityItem${i}`] && (
                                                    <Swiper
                                                        className="photo-swiper"
                                                        pagination={true}
                                                        loop={true}
                                                        autoplay={{
                                                            delay: 2000,
                                                            disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                                                        }}
                                                    >
                                                        {item.otherPicture.map((d, k) => {
                                                            return (
                                                                <SwiperSlide key={k}>
                                                                    <ImageAuto.Component width="100%" height="100%" src={d}></ImageAuto.Component>
                                                                </SwiperSlide>
                                                            );
                                                        })}
                                                    </Swiper>
                                                )}
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </div>
                    {this.renderEmbeddedView(BackTopBox.Page)}
                    {/*<div className="scoll-top">
                        <BackTop visibilityHeight={50} />
                    </div>*/}
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.about]);
}
